<template>
  <div class="bottom-layer">
    <div
      class="discount-wrapper"
      v-show="discountPrice !== 0"
      :style="discountColor"
    >
      <div class="lt">
        <img
          :src="require(`@/assets/images/detail/discount-icon.png`)"
          alt="discount icon"
        />
        <span>{{ $t('coupon.discount') }}</span>
      </div>
      <div class="rt">
        <GeneralPrice
          :className="'scribing'"
          :price="discountPrice"
          :injectColor="'#F96000'"
          :isRenderKB="true"
        />
        <MBIcon
          @click.stop="handleOpen"
          name="icon-arrow"
          :classNames="['arrow', isRender900Nav ? 'put-arrow' : '']"
          :size="14"
          color="#F96000"
        />
      </div>
    </div>
    <div class="submit-pc-wrapper" :style="payBgColor">
      <div class="lt">
        <div class="pay-price">
          <MyPriceTaxRate
            :isBeat="true"
            :price="finalPrice"
            :injectColor="priceColor.color"
          />
        </div>
        <div class="original-price" v-show="isRenderScribingPrice">
          {{ originalPriceText }}:&nbsp;&nbsp;
          <GeneralPrice
            :injectColor="priceColor.color"
            :className="'scribing'"
            :price="originalPrice"
            :isRenderKB="true"
          />
        </div>
      </div>
      <div class="rt">
        <div
          :class="['go-pay-btn', !submitButtonState ? 'not-click' : '']"
          :style="submitBgColor"
          @click="submitOrder"
        >
          <span>{{ submitText }}</span>
          <div class="submitBtnAnimation"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import MyPriceTaxRate from '@page_detail/components/MyPriceTaxRate'
  import GeneralPrice from '@/components/GeneralPrice'
  import MBIcon from '@/components/MBIcon'
  import calculatePrice from '@/mixins/detail/calculatePrice'
  import styleConfiguration from '@/mixins/detail/styleConfiguration'
  import { mapState, mapMutations } from 'vuex'
  export default {
    mixins: [calculatePrice, styleConfiguration],
    components: {
      MyPriceTaxRate,
      GeneralPrice,
      MBIcon,
    },
    props: {},
    data() {
      return {
        btnLoading: false,
      }
    },
    computed: {
      ...mapState(['gameName', 'userInfo', 'isDesktop']),
      ...mapState('detail', [
        'isRender900Nav',
        'submitButtonState',
        'userId',
        'isGenshinEn',
      ]),

      submitText() {
        const hackGames = ['soul-land3d', 'genshin-en', 'shining-nikki']
        let subText = ''

        if (hackGames.includes(this.gameName)) {
          subText = this.$t(`${this.gameName}.submit_btn_text`)
        } else {
          subText = this.$t('order.continue_to_pay')
        }

        return subText
      },

      originalPriceText() {
        return this.$t('common.originalPriceText')
      },
    },
    watch: {},
    created() {},
    mounted() {
      document.addEventListener('click', this.closeBottomLayer, false)
    },
    destroyed() {
      document.removeEventListener('click', this.closeBottomLayer, false)
    },
    methods: {
      ...mapMutations([
        'detail/setRenderPcNav',
        'detail/setExeOrderMethod',
        'detail/setUidFocus',
      ]),
      closeBottomLayer() {
        this['detail/setRenderPcNav'](false)
      },
      submitOrder() {
        const start = Date.now()
        if (this.awardType === 1 && this.userId.trim() === '') {
          this['detail/setUidFocus'](start)
          return
        }

        // 直接调用支付按钮
        this['detail/setExeOrderMethod'](start)
      },
      handleOpen() {
        this['detail/setRenderPcNav'](!this.isRender900Nav)
      },
    },
  }
</script>

<style lang="scss" scoped>
  @media screen and (min-device-width: 1080px) {
    @import './index_pc.scss';
  }
  @media (max-width: 900px) {
    @import './900.scss';
  }
</style>
